import BodyText from "components/Typography/BodyText"
import Heading from "components/Typography/Heading"
import { memo, ReactNode } from "react"
import styled from "styled-components"

const Divider = styled.div`
  border: 1px solid ${(props) => props.theme.palette.disabled};
  width: 292px;
`

const ContentSummaryContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`

const ContentSummaryListContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const ResultContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`

interface DefaultSummaryProps {
  totalPrice?: string
  fromPriceUnit: string
  label?: string
  children: ReactNode
}

const DefaultSummary = (props: DefaultSummaryProps) => {
  const { totalPrice = "", fromPriceUnit, label = "", children } = props

  return (
    <>
      <ContentSummaryContainer>
        <BodyText size="small" weight="light" color="gray-medium">
          {label}
        </BodyText>
        <ContentSummaryListContainer>{children}</ContentSummaryListContainer>
      </ContentSummaryContainer>
      <Divider />
      <ResultContainer>
        <Heading variant="h6">Total / {fromPriceUnit}</Heading>
        <Heading variant="h6" color="primary-dark">
          {totalPrice}
        </Heading>
      </ResultContainer>
    </>
  )
}

export default memo(DefaultSummary)
